module.exports = __webpack_public_path__ + "static/media/bg24.8169b087.jpg";